// extracted by mini-css-extract-plugin
export default {"settings":"SettingsPage_settings__dm84k","item":"SettingsPage_item__QS7Kl","customTextArea":"SettingsPage_customTextArea__1UCFc"};